import { useRefreshCandidate } from "#candidate/redux/actions"
import { useCandidateRedux } from "#candidate/redux/slice"
import { candidateIdPut } from "#candidate/services/api"
import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { Box, TextField, Typography } from "@mui/material"
import { Fragment, useCallback, useState } from "react"

export default function CandidateStatusDisabled({ open, setOpen }) {
	const [reason, setReason] = useState(null)
	const [disabled, setDisabled] = useState(false)
	const { candidateId, candidate } = useCandidateRedux()
	const { refresh } = useRefreshCandidate()

	const success = () => {
		setOpen(false)
		refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(candidateIdPut, { success, end })

	const handleSubmit = useCallback(() => {
		setDisabled(true)
		fetch(candidateId, {
			is_enabled: !candidate.is_enabled,
			reason,
		})
	}, [candidate.is_enabled, candidateId, fetch, reason])

	return (
		<Fragment>
			<DialogMaster
				{...{
					title: !candidate.is_enabled ? "Habilitar" : "Deshabilitar",
					open,
					setOpen,
					handleSubmit,
					disabled,
					maxWidth: "sm",
				}}
			>
				<Box display="flex" flexDirection="column" gap={2} alignItems={"center"}>
					<Typography variant="h6">
						Estas seguro de {!candidate.is_enabled ? "habilitar" : "deshabilitar"} al
						candidato
						<strong> {candidate.candidate_name}</strong>?
					</Typography>
					<TextField
						label="Motivo "
						value={reason}
						fullWidth
						onChange={(e) => setReason(e.target.value)}
					/>
				</Box>
			</DialogMaster>
		</Fragment>
	)
}
